import { useEffect, useRef } from "react";

/**
 * useReveal: lightweight intersection-observer-based fade-up.
 * Usage: const ref = useReveal(); <div ref={ref} className="reveal">...</div>
 */
export function useReveal(options = {}) {
  const ref = useRef(null);

  useEffect(() => {
    const node = ref.current;
    if (!node) return;
    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            obs.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, ...options }
    );
    obs.observe(node);
    return () => obs.disconnect();
  }, [options]);

  return ref;
}
